export default __webpack_public_path__ + "static/media/visa.a0ea4843.webp";